import * as Scrivito from "scrivito";
import React, { useEffect } from "react";
import { getCategoryClient, isActiveObj } from "utils";
import { useTranslate } from "hooks";
import { useSetIsLoaderXCircle } from "stores/loadingStateStore";
import type { ObjValidatorProps } from "interfaces/shared.types";

export const ObjValidator = Scrivito.connect(
  ({ page, children }: ObjValidatorProps) => {
    const translate = useTranslate();
    const isEditMode = Scrivito.isInPlaceEditingActive();
    const isDevEnv =
      process.env.TROX_ENVIRONMENT === "development" ||
      process.env.TROX_ENVIRONMENT === "local";

    const setIsLoaderXCircle = useSetIsLoaderXCircle();
    useEffect(() => () => setIsLoaderXCircle(true), [setIsLoaderXCircle]);

    const active = () => {
      const categoryClient = getCategoryClient() as string;
      if (!page) {
        return;
      }
      const categoryOwner = page.get("categoryOwner") as string[];

      return (
        (isActiveObj(page) && categoryOwner.includes(categoryClient)) ||
        isEditMode ||
        isDevEnv
      );
    };

    if (!active()) {
      return (
        <div className="container py-4">
          <h1>{translate("ERROR_PAGE_NOT_FOUND_TITLE")}</h1>
          {translate("ERROR_PAGE_NOT_FOUND_TEXT")}
          <br />
          <br />
          {translate("ERROR_PAGE_NOT_FOUND")}
        </div>
      );
    }

    return children;
  },
);
